import { searchCommonConfig } from './common'

/**
 * Storyella 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#0000000A',
    startReadingBg: 'linear-gradient(90deg, #FF6734 0.03%, #FF42CC 100%)',
  },
}
